import type { Item, Site } from '../../domain/inventory';

function normalizedLocationLabel(site: Site | undefined, locationSiteId: string): string {
  return (site?.displayName ?? site?.name ?? locationSiteId).trim().toLocaleLowerCase();
}

export function hasUnknownPhysicalLocation(
  item: Item,
  sitesById: ReadonlyMap<string, Site>,
): boolean {
  const locationSiteId = (item.locationSiteId ?? item.siteId).trim();
  if (!locationSiteId) return true;
  return normalizedLocationLabel(sitesById.get(locationSiteId), locationSiteId) === 'unknown';
}

export function isOperationallyVisible(item: Item, sitesById: ReadonlyMap<string, Site>): boolean {
  return item.status !== 'SCRAP' || !hasUnknownPhysicalLocation(item, sitesById);
}

/**
 * A read-only presentation rule. Records are never changed or removed from
 * the source system; unlocated scrap is simply omitted from operational
 * counts and lists where it cannot support a physical inventory decision.
 */
export function operationallyVisibleItems(
  items: Item[],
  sitesById: ReadonlyMap<string, Site>,
): Item[] {
  return items.filter((item) => isOperationallyVisible(item, sitesById));
}
